/**
 * Check if first Int32 is less than second
 *
 * @param {import('./Int32Type.js').BrandedInt32} a - First value
 * @param {import('./Int32Type.js').BrandedInt32} b - Second value
 * @returns {boolean} True if a < b
 */
export function lessThan(a, b) {
	return a < b;
}
